import { render, staticRenderFns } from "./JobApplications.vue?vue&type=template&id=5bbc6df3&"
import script from "./JobApplications.vue?vue&type=script&lang=js&"
export * from "./JobApplications.vue?vue&type=script&lang=js&"
import style0 from "./JobApplications.vue?vue&type=style&index=0&id=5bbc6df3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports